/**
 * Author: Claude Code
 * Generation: Step 3 - Agent strategy and personality definition
 * Version: v3.2.43
 * Modified: 2025-10-09
 */
import { useRoomStore } from '@store/RoomStore';

export default function Step3Strategy() {
  const { myAgentConfiguration, updateAgentPersonality, updateAgentStrategy } = useRoomStore();

  const personality = myAgentConfiguration?.personality || '';
  const strategy = myAgentConfiguration?.strategy || '';

  return (
    <div className="step-content active">
      <div className="step-header">
        <h3 className="step-title">Define Strategy</h3>
        <p className="step-subtitle">Shape your agent's personality and battle tactics</p>
      </div>

      {/* Strategy Hint */}
      <div className="strategy-hint">
        <div className="hint-header">
          <div className="hint-icon">💡</div>
          <div className="hint-title">Your Words Shape Your Agent's Mind</div>
        </div>
        <div className="hint-content">
          <p>
            <strong>Important:</strong> The natural language you provide directly influences how
            your agent behaves in combat. Be specific and clear!
          </p>
          <ul className="hint-examples">
            <li>
              ✓ "Prioritize weapon collection in early game" → Agent will actively seek weapons
            </li>
            <li>
              ✓ "Retreat when health below 30%" → Agent will play defensively when wounded
            </li>
            <li>
              ✓ "Aggressive hunter, engage on sight" → Agent will actively seek combat
            </li>
            <li>✗ "Be good" → Too vague, won't impact behavior effectively</li>
          </ul>
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Personality</label>
        <textarea
          className="textarea"
          rows={3}
          maxLength={200}
          placeholder="Describe your agent's character traits..."
          value={personality}
          onChange={(e) => updateAgentPersonality(e.target.value)}
        />
        <div className="char-counter">
          <span>{personality.length}</span> / 200
        </div>
      </div>

      <div className="form-group">
        <label className="form-label">Battle Strategy</label>
        <textarea
          className="textarea"
          rows={5}
          maxLength={500}
          placeholder="Define combat tactics and decision-making approach..."
          value={strategy}
          onChange={(e) => updateAgentStrategy(e.target.value)}
        />
        <div className="char-counter">
          <span>{strategy.length}</span> / 500
        </div>
      </div>

    </div>
  );
}
